import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProgressPage from './pages/ProgressPage';
import DonePage from './pages/DonePage';
import ErrorPage from './pages/ErrorPage';
import StatsPage from './pages/StatsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/done" element={<DonePage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/statystyki" element={<StatsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
